import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { FullBox, FullColumn } from 'seagull';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import BrandingControllers from '../../BrandingControllers/BrandingControllers';
import { COBStep } from '../../ClientOnboarding.utils';
import { OverrideBranding } from '../../CobBrandingContext';
import { useCobConfig } from '../../CobConfigContext';
import { PreviewBanner } from '../../PreviewBanner';
import { getVendorGradientStyle } from '../ClientOnboardingV2.utils';
import { CoverPage } from '../CoverPage/CoverPage';
import { OnboardingPage } from '../OnboardingPage/OnboardingPage';
import { animatePresenceVariants, pageTransition, pageVariants } from './animations.desktop';
import styles from './ClientOnboardingContentDesktop.module.scss';
export const ClientOnboardingContentDesktop = (param)=>{
    let { relationship, currentStep, previewState, localPreviewState, dismissPreviewModal, onToggleBrandSetup, showBrandSetupButton, setCurrentStep, visitedSteps, directionRef, hasVisitedCoverPageRef, handleBack, handleNext, statement, isStatementAccepted, onStatementChange, isNextDisabled, hideNextButton, hasSignedSuccess } = param;
    const isPreview = !!previewState;
    const isCoverPage = currentStep === COBStep.welcome;
    const worksAt = useStore(selectors.user.business);
    const { isSetupBrand } = useCobConfig();
    const handleGetStarted = ()=>{
        hasVisitedCoverPageRef.current = true;
        setCurrentStep(COBStep.introduction);
    };
    const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
    const coverPageContent = /*#__PURE__*/ _jsx(CoverPage, {
        relationship: relationship,
        onGetStarted: handleGetStarted,
        isPreview: isPreview,
        showRecipientToast: !hasVisitedCoverPageRef.current && !previewState
    });
    const onboardingPageContent = /*#__PURE__*/ _jsx(OnboardingPage, {
        relationship: relationship,
        currentStep: currentStep,
        direction: directionRef.current,
        onStepClick: setCurrentStep,
        onBack: handleBack,
        onNext: handleNext,
        visitedSteps: visitedSteps,
        statement: statement,
        isStatementAccepted: isStatementAccepted,
        onStatementChange: onStatementChange,
        isNextDisabled: isNextDisabled,
        hideNextButton: hideNextButton,
        hasSignedSuccess: hasSignedSuccess
    });
    return /*#__PURE__*/ _jsxs(FullColumn, {
        children: [
            isPreview && /*#__PURE__*/ _jsx(PreviewBanner, {
                previewState: previewState,
                localPreviewState: localPreviewState,
                onToggleBrandSetup: onToggleBrandSetup,
                onDismiss: dismissPreviewModal,
                showBrandSetupButton: showBrandSetupButton
            }),
            /*#__PURE__*/ _jsxs(FullBox, {
                flexDirection: "column",
                className: styles.contentBox,
                style: gradientStyle,
                children: [
                    /*#__PURE__*/ _jsx(FullBox, {
                        className: styles.overlay
                    }),
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        mode: "wait",
                        initial: false,
                        custom: isCoverPage,
                        children: /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                            custom: isCoverPage,
                            variants: pageVariants,
                            transition: pageTransition
                        }, animatePresenceVariants), {
                            className: styles.contentArea,
                            children: isCoverPage ? coverPageContent : onboardingPageContent
                        }), isCoverPage ? 'cover' : 'inner')
                    }),
                    isSetupBrand && worksAt && /*#__PURE__*/ _jsx(OverrideBranding, {
                        className: styles.setupBrandContainer,
                        testId: "setup-brand-section",
                        children: /*#__PURE__*/ _jsx(BrandingControllers, {
                            worksAt: worksAt
                        })
                    })
                ]
            })
        ]
    });
};
